import * as React from 'react';
import { Icon, SvgIcon } from '@mui/material';
import { ReactComponent as Innospec } from '../Img/Terpel.svg';

// Custom SVG Icon Component
const InnospecIcon = (props: any) => {
    return (
        <SvgIcon
            {...props}
            viewBox="0 0 600 233" // Use the viewBox from your SVG file
            component={Innospec}
            sx={{
              width: 'auto', // Let the height determine the width to maintain aspect ratio
              height: 80, // Default height
              ...props.sx, // Allow overriding via props
            }}
        />
    );
};

export default InnospecIcon;